"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CorporateAction = void 0;
const internal_1 = require("../../internal");
const internal_2 = require("../../utils/internal");
/**
 * Represents an action initiated by the issuer of an Asset which may affect the positions of
 *   the Asset Holders
 */
class CorporateAction extends internal_1.CorporateActionBase {
    /**
     * @hidden
     */
    constructor(args, context) {
        super(args, context);
        this.modifyCheckpoint = (0, internal_2.createProcedureMethod)({
            getProcedureAndArgs: modifyCaCheckpointArgs => [
                internal_1.modifyCaCheckpoint,
                Object.assign({ corporateAction: this }, modifyCaCheckpointArgs),
            ],
        }, context);
    }
}
exports.CorporateAction = CorporateAction;
//# sourceMappingURL=CorporateAction.js.map